export interface LoginRequest {

  loginType?: LoginTypeEnum;

  userIdentifier?: string;

  password?: string;

  platformUrl?: string;

}

export enum LoginTypeEnum {
  Email = 1,
  Cnp = 2,
  EmployeeCode = 3,
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LoginTypeLabels = {
  [LoginTypeEnum.Email]: 'Email',
  [LoginTypeEnum.Cnp]: 'CNP',
  [LoginTypeEnum.EmployeeCode]: 'Employee code'
};
